import React, { useState, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../services/api';

const fmt = n => Number(n || 0).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const printBill = (consumer, bill) => {
  const w = window.open('', '_blank', 'width=220,height=600');
  const balance = Number(bill.total_amount) - Number(bill.payment_amount);
  const dueDate = bill.due_date ? new Date(bill.due_date + 'T00:00:00').toLocaleDateString('en-PH', { month: 'short', day: 'numeric', year: 'numeric' }) : '-';
  w.document.write(`<!DOCTYPE html><html><head><title>Bill</title>
<style>
  @page { margin: 0; size: 58mm auto; }
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { font-family: 'Courier New', monospace; font-size: 11px; width: 48mm; padding: 2mm; line-height: 1.4; }
  .center { text-align: center; }
  .bold { font-weight: bold; }
  .line { border-top: 1px dashed #000; margin: 4px 0; }
  .row { display: flex; justify-content: space-between; }
  h1 { font-size: 13px; margin: 2px 0; }
  h2 { font-size: 11px; font-weight: normal; margin: 1px 0; }
  .big { font-size: 13px; font-weight: bold; }
</style></head><body>
  <div class="center">
    <h1>LOBOC MUNICIPAL</h1>
    <h1>WATERWORKS</h1>
    <h2>Statement of Account</h2>
  </div>
  <div class="line"></div>
  <div class="bold">${consumer.name}</div>
  <div>${consumer.account_code}</div>
  <div>${consumer.barangay_name}</div>
  ${consumer.address ? `<div>${consumer.address}</div>` : ''}
  <div class="line"></div>
  <div class="row"><span>Billing Period:</span><span class="bold">${bill.billing_period}</span></div>
  <div class="row"><span>Due Date:</span><span>${dueDate}</span></div>
  <div class="line"></div>
  <div class="row"><span>Prev Reading:</span><span>${bill.previous_reading}</span></div>
  <div class="row"><span>Curr Reading:</span><span>${bill.current_reading}</span></div>
  <div class="row bold"><span>Consumption:</span><span>${bill.consumption} cu.m.</span></div>
  <div class="line"></div>
  <div class="row"><span>Water Charge:</span><span>${Number(bill.water_charge).toFixed(2)}</span></div>
  ${Number(bill.past_due) > 0 ? `<div class="row"><span>Past Due:</span><span>${Number(bill.past_due).toFixed(2)}</span></div>` : ''}
  ${Number(bill.penalty) > 0 ? `<div class="row"><span>Penalty (2%):</span><span>${Number(bill.penalty).toFixed(2)}</span></div>` : ''}
  <div class="line"></div>
  <div class="row big"><span>TOTAL DUE:</span><span>PHP ${Number(bill.total_amount).toFixed(2)}</span></div>
  ${Number(bill.payment_amount) > 0 ? `<div class="row"><span>Less Paid:</span><span>(${Number(bill.payment_amount).toFixed(2)})</span></div>
  <div class="row big"><span>BALANCE:</span><span>PHP ${balance.toFixed(2)}</span></div>` : ''}
  <div class="line"></div>
  <div class="center" style="margin-top:6px;font-size:10px">Please pay on or before the<br>due date to avoid penalty.</div>
  <div class="center" style="font-size:9px;margin-top:4px">--- END ---</div>
  <script>window.onload=function(){window.print();}</script>
</body></html>`);
  w.document.close();
};

const printReceipt = ({ consumer, receiptNo, amount, bills, date, remainingBalance }) => {
  const w = window.open('', '_blank', 'width=220,height=600');
  const billRows = bills.map(b => `
    <tr><td>${b.billing_period}</td><td style="text-align:right">${Number(b.consumption || 0)} cu.m.</td><td style="text-align:right">${Number(b.total_amount - b.payment_amount).toFixed(2)}</td></tr>
  `).join('');
  w.document.write(`<!DOCTYPE html><html><head><title>Receipt</title>
<style>
  @page { margin: 0; size: 58mm auto; }
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { font-family: 'Courier New', monospace; font-size: 11px; width: 48mm; padding: 2mm; line-height: 1.4; }
  .center { text-align: center; }
  .bold { font-weight: bold; }
  .right { text-align: right; }
  .line { border-top: 1px dashed #000; margin: 4px 0; }
  .row { display: flex; justify-content: space-between; }
  table { width: 100%; border-collapse: collapse; font-size: 10px; }
  th, td { padding: 1px 0; }
  th { text-align: left; border-bottom: 1px solid #000; }
  h1 { font-size: 13px; margin: 2px 0; }
  h2 { font-size: 11px; font-weight: normal; margin: 1px 0; }
</style></head><body>
  <div class="center">
    <h1>LOBOC MUNICIPAL</h1>
    <h1>WATERWORKS</h1>
    <h2>Official Receipt</h2>
  </div>
  <div class="line"></div>
  <div class="row"><span>Date:</span><span>${date}</span></div>
  <div class="row"><span>OR No:</span><span class="bold">${receiptNo}</span></div>
  <div class="line"></div>
  <div class="bold">${consumer.name}</div>
  <div>${consumer.account_code}</div>
  <div>${consumer.barangay_name}</div>
  <div class="line"></div>
  <table>
    <thead><tr><th>Period</th><th style="text-align:right">Cons.</th><th style="text-align:right">Due</th></tr></thead>
    <tbody>${billRows}</tbody>
  </table>
  <div class="line"></div>
  <div class="row bold" style="font-size:13px"><span>PAID:</span><span>PHP ${Number(amount).toFixed(2)}</span></div>
  <div class="row"><span>Balance:</span><span>PHP ${Number(remainingBalance).toFixed(2)}</span></div>
  <div class="line"></div>
  <div class="center" style="margin-top:6px;font-size:10px">Thank you for your payment!</div>
  <div class="center" style="font-size:9px;margin-top:4px">--- END ---</div>
  <script>window.onload=function(){window.print();}</script>
</body></html>`);
  w.document.close();
};

export default function Payments() {
  const [searchResults, setSearchResults] = useState([]);
  const [selectedConsumer, setSelectedConsumer] = useState(null);
  const [unpaidBills, setUnpaidBills] = useState([]);
  const [recentPayments, setRecentPayments] = useState([]);
  const [search, setSearch] = useState('');
  const [payModal, setPayModal] = useState(null);
  const [payForm, setPayForm] = useState({ amount: '', receipt_no: '', send_sms: false });
  const [payAllModal, setPayAllModal] = useState(false);
  const [payAllForm, setPayAllForm] = useState({ amount: '', receipt_no: '', send_sms: false });
  const [searchParams] = useSearchParams();

  const loadRecent = useCallback(() => {
    api.get('/payments').then(r => setRecentPayments(r.data.recent_payments));
  }, []);

  useEffect(() => { loadRecent(); }, [loadRecent]);

  useEffect(() => {
    const cid = searchParams.get('consumer_id');
    if (cid) selectConsumer(parseInt(cid));
  }, []); // eslint-disable-line

  const doSearch = async (q) => {
    setSearch(q);
    if (q.length < 2) { setSearchResults([]); return; }
    const r = await api.get('/consumers/search', { params: { q } });
    setSearchResults(r.data);
  };

  const selectConsumer = async (id) => {
    setSearchResults([]); setSearch('');
    const r = await api.get('/payments', { params: { consumer_id: id } });
    setSelectedConsumer(r.data.consumer);
    setUnpaidBills(r.data.unpaid_bills);
    setRecentPayments(r.data.recent_payments);
  };

  const fetchNextReceipt = async () => {
    const r = await api.get('/payments/next-receipt');
    return r.data.receipt_no;
  };

  const openPay = async (bill) => {
    setPayModal(bill);
    const receipt = await fetchNextReceipt();
    setPayForm({ amount: (Number(bill.total_amount) - Number(bill.payment_amount)).toFixed(2), receipt_no: receipt, send_sms: false });
  };

  const openPayAll = async () => {
    const total = unpaidBills.reduce((s, b) => s + Number(b.total_amount) - Number(b.payment_amount), 0);
    const receipt = await fetchNextReceipt();
    setPayAllForm({ amount: total.toFixed(2), receipt_no: receipt, send_sms: false });
    setPayAllModal(true);
  };

  const submitPayAll = async () => {
    try {
      const paidAmount = parseFloat(payAllForm.amount);
      const today = new Date().toISOString().slice(0, 10);
      const totalDue = unpaidBills.reduce((s, b) => s + Number(b.total_amount) - Number(b.payment_amount), 0);
      await api.post('/payments/pay-all', {
        consumer_id: selectedConsumer.id,
        amount: paidAmount,
        payment_date: today,
        receipt_no: payAllForm.receipt_no,
        send_sms: payAllForm.send_sms,
      });
      printReceipt({
        consumer: selectedConsumer,
        receiptNo: payAllForm.receipt_no,
        amount: paidAmount,
        bills: unpaidBills,
        date: today,
        remainingBalance: Math.max(0, totalDue - paidAmount),
      });
      setPayAllModal(false);
      selectConsumer(selectedConsumer.id);
    } catch (e) { alert('Error: ' + (e.response?.data?.error || e.message)); }
  };

  const submitPayment = async () => {
    try {
      const paidAmount = parseFloat(payForm.amount);
      const today = new Date().toISOString().slice(0, 10);
      await api.post('/payments', {
        bill_id: payModal.id,
        amount: paidAmount,
        payment_date: today,
        receipt_no: payForm.receipt_no,
        send_sms: payForm.send_sms,
      });
      const billBalance = Number(payModal.total_amount) - Number(payModal.payment_amount) - paidAmount;
      const otherBalance = unpaidBills.filter(b => b.id !== payModal.id).reduce((s, b) => s + Number(b.total_amount) - Number(b.payment_amount), 0);
      printReceipt({
        consumer: selectedConsumer,
        receiptNo: payForm.receipt_no,
        amount: paidAmount,
        bills: [payModal],
        date: today,
        remainingBalance: Math.max(0, billBalance + otherBalance),
      });
      setPayModal(null);
      if (selectedConsumer) selectConsumer(selectedConsumer.id);
      else loadRecent();
    } catch (e) { alert('Error: ' + e.message); }
  };

  return (
    <div>
      <h1 className="page-title">Payments</h1>
      <div className="card">
        <h3>Search Consumer</h3>
        <input className="input" placeholder="Search by name or account code..." value={search} onChange={e => doSearch(e.target.value)} />
        {searchResults.length > 0 && (
          <div style={{ border: '1px solid #ddd', borderRadius: 6, marginTop: 8, maxHeight: 200, overflow: 'auto' }}>
            {searchResults.map(c => (
              <div key={c.id} style={{ padding: '10px 16px', cursor: 'pointer', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between' }}
                onClick={() => selectConsumer(c.id)}>
                <div><strong>{c.name}</strong><br /><span style={{color:'#666', fontSize:12}}>{c.account_code} - {c.barangay_name}</span></div>
                {c.balance > 0 && <span className="text-red">PHP {fmt(c.balance)}</span>}
              </div>
            ))}
          </div>
        )}
      </div>

      {selectedConsumer && (
        <div className="card">
          <div className="flex-between">
            <div><h3>{selectedConsumer.name}</h3><span style={{color:'#666'}}>{selectedConsumer.account_code} - {selectedConsumer.barangay_name}</span></div>
            <button className="btn btn-sm" style={{background:'#eee'}} onClick={() => { setSelectedConsumer(null); setUnpaidBills([]); loadRecent(); }}>Close</button>
          </div>
          <hr style={{margin:'12px 0'}} />
          {unpaidBills.length === 0 ? <p className="text-green">No unpaid bills</p> : (
            <>
              <h4>Unpaid Bills</h4>
              <div className="table-wrap">
                <table>
                  <thead>
                    <tr>
                      <th>Period</th>
                      <th className="text-right">Prev</th>
                      <th className="text-right">Current</th>
                      <th className="text-right">Cons.</th>
                      <th className="text-right">Charge</th>
                      <th className="text-right">Past Due</th>
                      <th className="text-right">Penalty</th>
                      <th className="text-right">Total</th>
                      <th className="text-right">Paid</th>
                      <th className="text-right">Balance</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {unpaidBills.map(b => (
                      <tr key={b.id}>
                        <td>{b.billing_period}</td>
                        <td className="text-right">{b.previous_reading}</td>
                        <td className="text-right">{b.current_reading}</td>
                        <td className="text-right">{b.consumption} cu.m.</td>
                        <td className="text-right">{fmt(b.water_charge)}</td>
                        <td className="text-right">{fmt(b.past_due)}</td>
                        <td className="text-right">{fmt(b.penalty)}</td>
                        <td className="text-right" style={{fontWeight:600}}>{fmt(b.total_amount)}</td>
                        <td className="text-right">{fmt(b.payment_amount)}</td>
                        <td className="text-right text-red" style={{fontWeight:600}}>{fmt(b.total_amount - b.payment_amount)}</td>
                        <td style={{whiteSpace:'nowrap'}}>
                          <button className="btn btn-primary btn-sm" style={{marginRight:4}} onClick={() => printBill(selectedConsumer, b)}>Print</button>
                          <button className="btn btn-success btn-sm" onClick={() => openPay(b)}>Pay</button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div style={{ marginTop: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 18, fontWeight: 'bold' }} className="text-red">
                  Total Balance: PHP {fmt(unpaidBills.reduce((s, b) => s + Number(b.total_amount) - Number(b.payment_amount), 0))}
                </span>
                <button className="btn btn-success" onClick={openPayAll}>Pay Total Balance</button>
              </div>
            </>
          )}
        </div>
      )}

      <div className="card">
        <h3>Recent Payments</h3>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Consumer</th><th>Period</th><th className="text-right">Amount</th><th>Date</th><th>Receipt</th></tr></thead>
            <tbody>
              {recentPayments.map(p => <tr key={p.id}><td>{p.consumer_name}</td><td>{p.billing_period}</td><td className="text-right">PHP {fmt(p.amount)}</td><td>{p.payment_date}</td><td>{p.receipt_no || '-'}</td></tr>)}
            </tbody>
          </table>
        </div>
      </div>

      {payAllModal && selectedConsumer && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div className="card" style={{ width: 400, margin: 16 }}>
            <h3>Pay Total Balance</h3>
            <p>{selectedConsumer.name} ({selectedConsumer.account_code})</p>
            <p className="text-red"><strong>Total Balance: PHP {fmt(unpaidBills.reduce((s, b) => s + Number(b.total_amount) - Number(b.payment_amount), 0))}</strong></p>
            <p style={{ fontSize: 13, color: 'var(--text-secondary)' }}>Payment will be applied to {unpaidBills.length} bill(s), oldest first.</p>
            <div className="form-group" style={{marginTop:16}}>
              <label className="label">Payment Amount</label>
              <input className="input" type="number" step="0.01" value={payAllForm.amount} onChange={e => setPayAllForm(f => ({...f, amount: e.target.value}))} />
            </div>
            <div className="form-group">
              <label className="label">Receipt No.</label>
              <input className="input" value={payAllForm.receipt_no} onChange={e => setPayAllForm(f => ({...f, receipt_no: e.target.value}))} />
            </div>
            <div className="form-group">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input type="checkbox" checked={payAllForm.send_sms} onChange={e => setPayAllForm(f => ({...f, send_sms: e.target.checked}))} />
                <span style={{ fontSize: 14 }}>Send SMS receipt to consumer</span>
              </label>
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn" style={{background:'#eee'}} onClick={() => setPayAllModal(false)}>Cancel</button>
              <button className="btn btn-success" onClick={submitPayAll}>Record Payment</button>
            </div>
          </div>
        </div>
      )}

      {payModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div className="card" style={{ width: 400, margin: 16 }}>
            <h3>Pay Bill - {payModal.billing_period}</h3>
            <p>Total: PHP {fmt(payModal.total_amount)}</p>
            <p>Paid: PHP {fmt(payModal.payment_amount)}</p>
            <p className="text-red"><strong>Balance: PHP {fmt(payModal.total_amount - payModal.payment_amount)}</strong></p>
            <div className="form-group" style={{marginTop:16}}>
              <label className="label">Payment Amount</label>
              <input className="input" type="number" step="0.01" value={payForm.amount} onChange={e => setPayForm(f => ({...f, amount: e.target.value}))} />
            </div>
            <div className="form-group">
              <label className="label">Receipt No.</label>
              <input className="input" value={payForm.receipt_no} onChange={e => setPayForm(f => ({...f, receipt_no: e.target.value}))} />
            </div>
            <div className="form-group">
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                <input type="checkbox" checked={payForm.send_sms} onChange={e => setPayForm(f => ({...f, send_sms: e.target.checked}))} />
                <span style={{ fontSize: 14 }}>Send SMS receipt to consumer</span>
              </label>
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button className="btn" style={{background:'#eee'}} onClick={() => setPayModal(null)}>Cancel</button>
              <button className="btn btn-success" onClick={submitPayment}>Record Payment</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
